module.exports = __webpack_public_path__ + "r-v3/img/ico_arrowLineThickLeft_white.4a220816.svg";